export enum EGalleryTypeAncillary {
  ART = 'ART',
  Owner = 'Owner',
}
export enum EGalleryTypeFirearm {
  FRT = 'FRT',
  Owner = 'Owner',
}
